import {
	ReactElement
} from "react";
import { useIsTouchDevice } from "client/Hooks";
import { generateTrackingId } from "client/Misc/utils";
import { EmojiPicker } from "client/Components/EmojiPicker/EmojiPicker";
import { ButtonPopupControl } from "./ButtonPopupControl";

export type InsertEmojiControlProps = {
	onInsertEmoji(emojiUnicode: string): void;
	trackingId: string;
	isDisabled?: boolean;
	tooltip: string;
};

export const InsertEmojiControl = (props: InsertEmojiControlProps): ReactElement | null => {
	const {
		onInsertEmoji,
		trackingId,
		isDisabled = false,
		tooltip
	} = props;

	const isTouch: boolean = useIsTouchDevice();

	if (isTouch) {
		return null;
	}

	return (
		<ButtonPopupControl
			icon="face-smile"
			trackingId={trackingId}
			isDisabled={isDisabled}
			tooltip={tooltip}
		>
			{({ target, onClose }): ReactElement => (
				<EmojiPicker
					target={target}
					onClose={onClose}
					onSelected={onInsertEmoji}
					trackingId={generateTrackingId(trackingId, "__picker")}
				/>
			)}
		</ButtonPopupControl>
	);
};
InsertEmojiControl.displayName = "InsertEmojiControl";
